import React from 'react';
import Image from 'next/image';
import Box from '@mui/material/Box';
import { useT } from '@transifex/react';
import { ContentBlockWrapper, ContentWrapper } from '@raisin/components-lib';
import ChevronLeft from '@raisin/components-lib/Icons/ChevronLeft';
import { getResizedImageUrl, useFeatureFlag } from '@raisin/cp-utils';
import BankInfo from '../../BankInfo';
import * as S from './styles';

const BankDetailsHeader = ({
  bank,
  locale,
  bankInfo,
  messages,
  getBankPageLink,
  selectedOfferId,
}) => {
  const t = useT();
  const { variation } = useFeatureFlag();
  const shouldUseBankSlugFallback = variation?.('b2CShouldUseBankSlugFallback', false);

  return (
    <ContentBlockWrapper backgroundColor="background">
      <ContentWrapper>
        <S.BankDetailsHeaderContainer component="section">
          <S.BankDetailsInfoContainer>
            <S.BackButtonContainer>
              <S.BackButton
                href={getBankPageLink(locale, shouldUseBankSlugFallback, '', '')}
                data-testid="back-button"
                mode="primaryText"
                hidden={!!selectedOfferId}
                startIcon={<ChevronLeft />}
              >
                <span>{t(messages.backButton)}</span>
              </S.BackButton>
            </S.BackButtonContainer>
            <S.BankDetailsInfo>
              <S.BankDetailsInfoLayout>
                <S.BankNameTitle variant="h2">{bank.name}</S.BankNameTitle>
                <BankInfo data={bankInfo} />
              </S.BankDetailsInfoLayout>
            </S.BankDetailsInfo>
          </S.BankDetailsInfoContainer>
          <Box
            sx={{
              display: 'flex',
              justifyContent: { lg: 'center', md: 'flex-start' },
              alignItems: 'flex-start',
              pl: { sm: 0, lg: 6 },
            }}
          >
            <S.LogoContainer>
              <Image
                src={getResizedImageUrl({
                  resizableUrl: bank?.logo_url,
                  fallbackUrl: bank?.bank_logo_url,
                  params: { width: 320 },
                })}
                width={300}
                height={300}
                alt={`logo of ${bank.name}`}
              />
            </S.LogoContainer>
          </Box>
        </S.BankDetailsHeaderContainer>
      </ContentWrapper>
    </ContentBlockWrapper>
  );
};

export default BankDetailsHeader;
